import React, { useEffect, useImperativeHandle, useState } from 'react';
import { Col, Form, InputGroup, Row } from 'react-bootstrap';
import {
  fetchEquipmentModals,
  getModalByMfrs,
} from '../../app/equipment/equipmentModalsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { allowOnlyNumbers, optionMapper, months } from '../constant';
import {
  CP_KEY,
  calculateMaxCPwr,
  getInitialValues,
  getValidationSchema,
} from './helpers';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const QuantityMakeModal = React.forwardRef((props, ref) => {
  const {
    makeList,
    modalList,
    eqId,
    pId,
    name,
    onDelete,
    hideIcons,
    isSolarArray,
    item,
    pageType
  } = props;
  const dispatch = useDispatch();
  const modalListByMfrs = useSelector(getModalByMfrs);
  const [hideAziTilt, setHideAziTilt] = useState(false);
  const isView =  pageType==='view'

  const {
    register,
    watch,
    handleSubmit,
    setValue,
    getValues,
    reset,
    trigger,
    clearErrors,
    formState: { errors, isValid, isValidating },
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(getValidationSchema(isSolarArray)),
    defaultValues: getInitialValues(isSolarArray),
  });

  useEffect(() => {
    if (modalListByMfrs) {
      props.onUpdateModals(modalListByMfrs);
    }
  }, [modalListByMfrs]);

  const renderError = (key, style) =>
    errors?.[key]?.message && (
      <Form.Control.Feedback type="invalid" style={style}>
        {errors?.[key]?.message}
      </Form.Control.Feedback>
    );

  //HOOK FORM FILEDS HERE
  const qtyField = register(CP_KEY.QTY, { required: true });
  const mfrFiled = register(CP_KEY.MFR, { required: true });
  const mdlFiled = register(CP_KEY.MDL, { required: true });

  const onQtyChange = (e) => {
    const value = e.target.value;
    e.target.value = allowOnlyNumbers(value);
    qtyField.onChange(e);
  };

  const onMfrChange = (e) => {
    props.setUpdateId({ eqId: eqId, pId: pId });
    const reqObj = { EquipmentType: name, ManufacturerName: e.target.value };
    dispatch(fetchEquipmentModals(reqObj));
    if (e.target.value) {
      clearErrors(CP_KEY.MFR);
      clearErrors(CP_KEY.MDL);
      setValue(CP_KEY.MDL, '');
      onModalChange(e);
    }
    mfrFiled.onChange(e);
  };

  const onModalChange = (e) => {
    if (e.target.value) {
      clearErrors(CP_KEY.MDL);
    }
    const modelData = modalList?.find((i) => i.MDL_NM === e.target.value);
    props.onDataUpdate(
      {
        modelData: modelData,
        smdl: e.target.value,
        ...(pId ? {} : { battery: [], solar: [] }),
      },
      eqId,
      pId
    );
    mdlFiled.onChange(e);
  };

  const triggerQtyForm = () => {
    trigger();
    return isValid;
  };

  useImperativeHandle(ref, () => ({
    triggerQtyForm,
  }));
  const qtyVal = watch(CP_KEY.QTY, '');
  const mfrVal = watch(CP_KEY.MFR, '');
  const modalVal = watch(CP_KEY.MDL, '');

  useEffect(() => {
    trigger();
  }, [qtyVal, mfrVal, modalVal]);

  useEffect(() => {
    props.onDataUpdate({ data: getValues(), isValid: isValid }, eqId, pId);
  }, [isValidating]);

  useEffect(() => {
    if (props.item.data && props.formData?.data) {
      setValue(CP_KEY.QTY, props.item.data?.[CP_KEY.QTY]);
      setValue(CP_KEY.MFR, props.item.data?.[CP_KEY.MFR]);
      setValue(CP_KEY.MDL, props.item.data?.[CP_KEY.MDL]);
      if (isSolarArray) {
        setValue(CP_KEY.PV_TILT, props.item.data?.[CP_KEY.PV_TILT]);
        setValue(CP_KEY.PV_AZI, props.item.data?.[CP_KEY.PV_AZI]);
        setValue(CP_KEY.PV_TRK, props.item.data?.[CP_KEY.PV_TRK]);
        months.forEach((i) => {
          setValue(i, props.item.data?.[i]);
        });
      }
    }
  }, [props.formData?.data]);

  return (
    <React.Fragment key={eqId}>
      <Row>
        <Col>
          <Form.Text size="sm" style={{ margin: '2px' }}>
            Quantity
          </Form.Text>
          <InputGroup className="mb-3">
            <InputGroup.Text style={{ background: '#cbc5c5' }}>
              Qty
            </InputGroup.Text>
            <Form.Control
              {...qtyField}
              isInvalid={errors[CP_KEY.QTY]}
              maxLength={3}
              placeholder="Quantity"
              aria-label="qty"
              onChange={onQtyChange}
              disabled={isView}
            />
            {renderError(CP_KEY.QTY)}
          </InputGroup>
        </Col>

        {makeList?.length > 0 && (
          <Col>
            <Form.Text size="sm" style={{ margin: '13px' }}>
              Manufacturer
            </Form.Text>
            <Form.Select
              size="sm"
              aria-label="make"
              {...mfrFiled}
              isInvalid={errors[CP_KEY.MFR]}
              onChange={onMfrChange}
              disabled={isView}
            >
              <option value="">Please select</option>
              {optionMapper(makeList)}
            </Form.Select>
            {renderError(CP_KEY.MFR, { marginLeft: '10px' })}
          </Col>
        )}
        {modalList?.length > 0 && (
          <Col>
            <Form.Text size="sm" style={{ margin: '13px' }}>
              Model
            </Form.Text>
            <Form.Select
              size="sm"
              aria-label="modal"
              {...mdlFiled}
              isInvalid={errors[CP_KEY.MDL]}
              onChange={onModalChange}
              disabled={isView}
            >
              <option value="">Please select</option>
              {optionMapper(modalList, 'MDL_NM')}
            </Form.Select>
            {renderError(CP_KEY.MDL, { marginLeft: '10px' })}
          </Col>
        )}
        {(!hideIcons && !isView) && (
          <Col xs={1} style={{ paddingTop: '25px' }}>
            <span onClick={() => onDelete()}>
              <FontAwesomeIcon icon={['fas', 'trash-alt']} size="md" />
            </span>
          </Col>
        )}
      </Row>
      {/* SOLAR CONTENT BELOW  */}
      {isSolarArray && (
        <>
          <Form.Text size="sm" style={{ marginTop: '-10px' }}>
            {item?.modelData?.NMP_CAP_UNIT_KW &&
              item?.data?.[CP_KEY.QTY] &&
              `Nameplate Energy Capacity(kW):${calculateMaxCPwr(
                item?.modelData?.NMP_CAP_UNIT_KW,
                item?.data?.[CP_KEY.QTY]
              )}`}{' '}
          </Form.Text>
          <Row>
            {!hideAziTilt && (
              <>
                <Col>
                  <Form.Text id="tilt" muted>
                    Tilt (0-90 deg)
                  </Form.Text>
                  <Form.Control
                    id="tilt"
                    {...register(CP_KEY.PV_TILT)}
                    isInvalid={errors[CP_KEY.PV_TILT]}
                    aria-describedby="tilt"
                    maxLength={2}
                    onChange={(e) => {
                      const value = e.target.value;
                      e.target.value =
                        allowOnlyNumbers(value) <= 90
                          ? allowOnlyNumbers(value)
                          : 90;
                    }}
                    disabled={isView}
                  />
                  {renderError(CP_KEY.PV_TILT)}
                </Col>
                <Col>
                  <Form.Text id="ptc-rating" muted>
                    Azimuth (0-359 deg)
                  </Form.Text>
                  <Form.Control
                    id="azimuth"
                    {...register(CP_KEY.PV_AZI)}
                    isInvalid={errors[CP_KEY.PV_AZI]}
                    aria-describedby="azimuth"
                    maxLength={3}
                    onChange={(e) => {
                      const value = e.target.value;
                      e.target.value =
                        allowOnlyNumbers(value) <= 359
                          ? allowOnlyNumbers(value)
                          : 359;
                    }}
                    disabled={isView}
                  />
                  {renderError(CP_KEY.PV_AZI)}
                </Col>
              </>
            )}
            <Col>
              <Form.Text id="ptc-rating" muted>
                Tracking
              </Form.Text>
              <Form.Select
                {...register(CP_KEY.PV_TRK)}
                isInvalid={errors[CP_KEY.PV_TRK]}
                onChange={(e) => {
                  if (e.target.value === 'dual') {
                    setValue(CP_KEY.PV_TILT, '');
                    setValue(CP_KEY.PV_AZI, '');
                    setHideAziTilt(true);
                  } else {
                    setHideAziTilt(false);
                    trigger(CP_KEY.PV_AZI);
                    trigger(CP_KEY.PV_TILT);
                  }
                }}
                disabled={isView}
                size="sm"
                aria-label="modal"
              >
                <option>Please select</option>
                <option value="fixed">Fixed</option>
                <option value="single">Single Axis</option>
                <option value="dual">Dual Axis</option>
              </Form.Select>
              {renderError(CP_KEY.PV_TRK)}
            </Col>
          </Row>
          <Row style={{ marginTop: '10px' }}>
            <Col>
              <Form.Text id="ptc-rating" muted>
                %Shading <br />% solar access
              </Form.Text>
            </Col>
            {months.map((item) => {
              return (
                <Col>
                  <Form.Text id="ptc-rating" muted>
                    {item}
                  </Form.Text>
                  <Form.Control
                    size="sm"
                    {...register(item)}
                    isInvalid={errors[item]}
                    id={item}
                    aria-describedby={item}
                    maxLength={3}
                    onChange={(e) => {
                      const value = e.target.value;
                      e.target.value =
                        allowOnlyNumbers(value) <= 100
                          ? allowOnlyNumbers(value)
                          : 100;
                    }}
                    disabled={isView}
                  />
                </Col>
              );
            })}
          </Row>
        </>
      )}
    </React.Fragment>
  );
});

export default QuantityMakeModal;
